export const DEFAULT_LAYOUT = {
desk:{
  desk1:  { rotation: 0, x: 40,  y: 40 },
  desk2:  { rotation: 0, x: 160, y: 40 },
  desk3:  { rotation: 0, x: 280, y: 40 },
  desk4:  { rotation: 0, x: 400, y: 40 },
  desk5:  { rotation: 0, x: 600, y: 40 },
  desk6:  { rotation: 0, x: 720, y: 40 },
  desk7:  { rotation: 0, x: 840, y: 40 },
  desk8:  { rotation: 0, x: 960, y: 40 },
  desk9:  { rotation: 0, x: 40,  y: 120 },
  desk10: { rotation: 0, x: 960, y: 120 },
  desk11: { rotation: 0, x: 560, y: 560 },
  desk12: { rotation: 0, x: 440, y: 560 },
  desk13: { rotation: 0, x: 480, y: 200 },
  desk14: { rotation: 0, x: 960, y: 360 },
  desk15: { rotation: 0, x: 960, y: 440 },
  desk16: { rotation: 0, x: 960, y: 200 },
  desk17: { rotation: 0, x: 40,  y: 520 },
  desk18: { rotation: 0, x: 40,  y: 200 },
  desk19: { rotation: 0, x: 40,  y: 680 },
  desk20: { rotation: 0, x: 600, y: 200 },
  desk21: { rotation: 0, x: 400, y: 360 },
  desk22: { rotation: 0, x: 600, y: 360 },
  desk23: { rotation: 0, x: 840, y: 360 },
  desk24: { rotation: 0, x: 960, y: 520 },
  desk25: { rotation: 0, x: 40,  y: 600 },
  desk26: { rotation: 0, x: 40,  y: 440 },
  desk27: { rotation: 0, x: 40,  y: 360 },
  desk28: { rotation: 0, x: 160, y: 360 },
  desk29: { rotation: 0, x: 280, y: 360 },
  desk30: { rotation: 0, x: 720, y: 360 },
  desk31: { rotation: 0, x: 960, y: 680 },
  desk32: { rotation: 0, x: 960, y: 600 }
},
seating:{}
};
